import { PlatformLocation } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-step-company-social',
  templateUrl: './step-company-social.component.html',
  styleUrls: ['./step-company-social.component.scss']
})
export class StepCompanySocialComponent implements OnInit {

  form: FormGroup;
  @Output() submited: EventEmitter<boolean>;
  @Output() formObserver: Subject<FormGroup>;
  mauticFormSrc: any = null;
  showPassword: boolean = false;

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation
  ) {

    this.form = fb.group({
      email: [localStorage.getItem('email'), Validators.required],
      site: [null],
      facebook: [null],
      instagram: [null],
      youtube: [null]
    })
    this.submited = new EventEmitter<any>();
    this.formObserver = new Subject<FormGroup>();

  }

  ngOnInit(): void {

    this.formObserver.next(this.form);

  }

  onSubmit(): void {

    if (!this.form.invalid) {
      const data = this.form.getRawValue();
      const params = new URLSearchParams();
      for (let key in data) {
        const value = data[key];
        if (value)
          params.append(key, value);
      }
      const bHref = this.pLocation.getBaseHrefFromDOM();
      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-company-social?${params.toString()}`);
      setTimeout(() => this.submited.emit(), 5000);

    }

  }

}
